import Link from "next/link";
import styled, {css} from "styled-components";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";

export const Button = styled(ForceSSRLink)`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ width }) => width || 'fit-content'};
    padding: 0 15px;
    height: 39px;
    //line-height: 39px;
    font-size: 15px;
    //line-height: 15px;
    font-family: 'Josefin Sans',sans-serif;
    text-decoration: none;
    white-space: nowrap;
    border: 1px solid;

    margin: 0; /* Removes extra margin */
    line-height: 1; /* Sets line height to exactly the text height */
    vertical-align: baseline; /* Prevents alignment gaps */

    ${({ variant }) => {
        switch (variant) {
            case 'green_giant':
                return css`
                    margin-top: 50px;
                    width: 100%;
                    padding: 10px 80px;
                    height: 50px;
                    font-size: 18px;
                    font-weight: bold;

                    background-color: #134633;
                    color: #fff;
                    border-color: #134633;

                    &:hover {
                        background-color: #859f95;
                        border-color: #859f95;
                        color: black;
                    }
                `
            case 'greenTextImageSection':
                return css`
                    padding: 5px 49px;
                    align-items: center;
                    justify-content: center;
                    height: 50px;
                    color: #fff !important;
                    text-decoration: none !important;
                    background: #144733;
                    font-size: 14px;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    -webkit-transition: all .2s linear;
                    -moz-transition: all .2s linear;
                    -ms-transition: all .2s linear;
                    -o-transition: all .2s linear;
                    transition: all .2s linear;

                    &:hover {
                        background-color: #0f3a2c;
                    }
                `;
            case 'green':
                return css`
                    background-color: #134633;
                    color: #fff;
                    border-color: #134633;

                    &:hover {
                        background-color: #0f3a2c;
                    }
                `;
            case 'blue':
                return css`
                    background-color: #033769;
                    color: #fff;
                    border-color: #033769;

                    &:hover {
                        color:${getColor('gold')};
                    }
                `;
            case 'black':
                return css`
                    background-color: black;
                    color: #fff;
                    border-color: black;

                    &:hover {
                        background-color: gray;
                        border-color: gray;
                    }
                `;
            case 'outlineBlack':
                return css`
                    background-color: #fff;
                    color: #000;
                    border-color: #000;

                    &:hover {
                        background-color: #f2f2f2;
                    }
                `;
            case 'gold':
                return css`
                    background-color: ${getColor('gold')};
                    color: black;
                    border-color: ${getColor('gold')};

                    &:hover {
                        background-color: ${getColor('black')};
                        color: white;
                        border-color: ${getColor('black')};
                    }
                `;
            case 'goldLarge':
                return css`
                    height: fit-content;
                    padding: 15px 80px;
                    background-color: ${getColor('gold')};
                    color: black;
                    border-color: ${getColor('gold')};
                    text-transform: uppercase;

                    @media only screen and (${breakpoints.mobile}) {
                        padding: 15px 40px;
                    }
                    
                    &:hover {
                        background-color: ${getColor('black')};
                        color: white;
                        border-color: ${getColor('black')};
                    }
                `;
            default:
                return css`
                    background-color: #ccc;
                    color: black;
                    border-color: #ccc;

                    &:hover {
                        background-color: #bbb;
                    }
                `;
        }
    }}
`;
